import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsletterComponent } from '../../shared/components/newsletter/newsletter.component';

interface FaqItem {
  question: string;
  answer: string;
  isOpen: boolean;
}

@Component({
  selector: 'app-help-center',
  standalone: true,
  imports: [NewsletterComponent, CommonModule],
  templateUrl: './help-center.component.html',
  styleUrl: './help-center.component.css'
})
export class HelpCenterComponent {
  faqItems: FaqItem[] = [
    {
      question: 'Nasıl otel rezervasyonu yapabilirim?',
      answer: 'Ana sayfamızda gitmek istediğiniz destinasyonu, giriş-çıkış tarihlerini ve misafir sayısını girerek arama yapabilirsiniz. Çıkan sonuçlardan size uygun oteli seçip, oda tipini belirleyerek rezervasyonunuzu tamamlayabilirsiniz.',
      isOpen: false
    },
    {
      question: 'Ödeme yöntemleri nelerdir?',
      answer: 'Kredi kartı ve banka kartı ile güvenli bir şekilde ödeme yapabilirsiniz. Tüm ödemeleriniz 256-bit SSL şifreleme ile korunmaktadır. Taksitli ödeme seçenekleri için bankanızın kampanyalarını kontrol edebilirsiniz.',
      isOpen: false
    },
    {
      question: 'Rezervasyonumu nasıl iptal edebilirim?',
      answer: 'Rezervasyon iptal işlemleri için müşteri hizmetlerimizi aramanız veya destek@pusulatatil.com adresine e-posta göndermeniz gerekmektedir. İptal koşulları ve iade politikası, seçtiğiniz otelin kurallarına göre değişiklik gösterebilir.',
      isOpen: false
    },
    {
      question: 'Çocuklar için ücretlendirme nasıl yapılır?',
      answer: 'Çocuk ücretlendirmesi otelden otele farklılık gösterir. Genellikle 0-6 yaş arası çocuklar ücretsiz konaklayabilir, 7-12 yaş arası çocuklar için indirimli tarife uygulanır. Detaylı bilgi için rezervasyon sırasında çocuk yaşlarını girmeniz yeterlidir.',
      isOpen: false
    },
    {
      question: 'Rezervasyon onayımı nasıl alırım?',
      answer: 'Rezervasyonunuz tamamlandıktan sonra, kayıtlı e-posta adresinize otomatik olarak onay maili gönderilir. Bu mailde rezervasyon detaylarınız, otel bilgileri ve voucher kodunuz yer alır. Otele giriş yaparken bu belgeyi göstermeniz yeterlidir.',
      isOpen: false
    },
    {
      question: 'Müşteri hizmetlerine nasıl ulaşabilirim?',
      answer: '7/24 müşteri hizmetlerimize 0242 212 02 24 numaralı telefondan veya destek@pusulatatil.com e-posta adresinden ulaşabilirsiniz. Ayrıca web sitemizdeki iletişim formu üzerinden de bize mesaj gönderebilirsiniz.',
      isOpen: false
    }
  ];

  toggleFaq(index: number): void {
    this.faqItems[index].isOpen = !this.faqItems[index].isOpen;
  }
}
